import React, { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faTimes, faCalendarDays, faMagnifyingGlass, faChevronLeft, faXmark } from '@fortawesome/free-solid-svg-icons' // <-- import styles to be used
import { MDBInput } from 'mdbreact';
import { BiImageAdd } from "react-icons/bi";
import { CiBoxList } from "react-icons/ci";
import { MdOutlineChecklist } from "react-icons/md";
import { ImPencil } from "react-icons/im";
import { FaTrashAlt } from "react-icons/fa";


const CreaQuiz = ({quiz, setQuiz, tipo}) => {

    const CreaPregunta = (tipo) => {

        if (tipo === 'abc') {
            setQuiz([...quiz, {
                tipo: 'abc', pregunta: '', acertada: '', respuestas: [
                    { id: 'a', texto: '' },
                    { id: 'b', texto: '' },
                    { id: 'c', texto: '' },
                    { id: 'd', texto: '' }
                ]
            }])
        } else if (tipo === 'falsoverdadero') {
            setQuiz([...quiz, {
                tipo: 'falsoverdadero', pregunta: '', acertada: '', respuestas: ['Falso', 'Verdadero']
            }])
        } else if (tipo === 'frase') {
            setQuiz([...quiz, {
                tipo: 'frase', pregunta: '', acertada: '', respuestas: [
                    { frase: '', respuesta: '' },
                    { frase: '', respuesta: '' },
                    { frase: '', respuesta: '' },
                    { frase: '', respuesta: '' }
                ]
            }])
        }else if (tipo === 'foto') {
            setQuiz([...quiz, {
                tipo: 'foto', pregunta: '', acertada: '', respuestas: []
            }])
        }

    }

    // const CreaPregunta = () => {
    //     console.log('paso')
    //     setQuiz([...quiz, {
    //         id: numPregunta + 1, pregunta: '', acertada: '', respuestas: [
    //             { id: 'a', pregunta: '' },
    //             { id: 'b', pregunta: '' },
    //             { id: 'c', pregunta: '' },
    //             { id: 'd', pregunta: '' }
    //         ]
    //     }])
    //     setNumPregunta(numPregunta + 1)
    // }

    // const EditaPregunta = (dato, idPregunta) => {
    //     let copia = quiz
    //     console.log(dato)
    //     copia.map(item => {
    //         if (item.id === idPregunta) {
    //             item.id = item.id
    //             item.pregunta = dato
    //             item.acertada = item.acertada
    //             item.respuestas = item.respuestas
    //         }
    //     })
    //     console.log('copia', copia)
    //     setQuiz(copia)
    // }

    const editaPregunta = (e, index) => {
        const copia = [...quiz]
        copia[index][e.target.name] = e.target.value
        setQuiz(copia)
    }

    const editaOpcion = (e, indexPregunta, indexRespuesta) => {
        const copia = [...quiz]
        console.log('indexPregunta', indexPregunta)
        console.log('indexRespuesta', indexRespuesta)
        copia[indexPregunta].respuestas[indexRespuesta][e.target.name] = e.target.value
        setQuiz(copia)
    }

    const EliminarPregunta = (index) => {
        let copia = [...quiz]
        copia.splice(index, 1)
        setQuiz(copia)
    }

    return (
        <div className='CreaQuiz'>
            <div className='HeaderCreaQuiz'>
                {tipo === 'quiz' ?
                <div className='HeaderCreaQuizTexto'>
                    <h5>Crea el Quiz:</h5>
                    <p>Todas las preguntas se presentaran en orden Aleatorio</p>
                </div>
                :
                <div className='HeaderCreaQuizTexto'>
                    <h5>Crea un Trabajo Final:</h5>
                    <p>Cada pregunta corresponde a 1 archivo de Imagen</p>
                </div>
                }
                {tipo === 'quiz' ?
                    <div className='HeaderCreaQuizBotones'>
                        <button
                            onClick={e => CreaPregunta('abc')}
                            className="btn boton_estandar_blanco btn-lg derecha">
                            <CiBoxList />
                        </button>
                        <button
                            onClick={e => CreaPregunta('falsoverdadero')}
                            className="btn boton_estandar_blanco btn-lg derecha">
                            <MdOutlineChecklist />
                        </button>
                        <button
                            onClick={e => CreaPregunta('frase')}
                            className="btn boton_estandar_blanco btn-lg derecha">
                            <ImPencil />
                        </button>
                    </div>
                : 
                    <div className='HeaderCreaQuizBotones'>
                        <button
                            onClick={e => CreaPregunta('foto')}
                            className="btn boton_estandar_blanco btn-lg derecha">
                            <BiImageAdd />
                        </button>
                    </div>
                }
            </div>
            <div className="CuerpoCreaQuiz">

                {quiz.map((item, index) => {
                    return (
                        <div key={index}>
                            {/* // ---HEADER */}
                            <div className='HeaderCreaQuiz'>
                                <div style={{ flex: 4 }}><h5>Pregunta {index + 1}: <span>({item.tipo})</span></h5> </div>
                                <div style={{ flex: 1, textAlign: 'right' }}>
                                    <button className='boton_estandar_blanco btnEliminarQuiz' onClick={e => EliminarPregunta(index)}><FaTrashAlt /></button>
                                </div>
                            </div>
                            {/* // --- PREGUNTA */}
                            {item.tipo !== 'frase' ?
                                <div className='form-group'>
                                    <input
                                        onChange={e => editaPregunta(e, index)}
                                        name="pregunta"
                                        value={item.pregunta}
                                        type="buscador" className="form-control" placeholder="Escribe Pregunta">
                                    </input>
                                </div>
                                :
                                <div className='form-group'>
                                    <b>Frase: </b>
                                    {quiz[index].respuestas.map((item, indexxx) => {
                                        return (
                                            <spam key={indexxx}>{item.frase} <spam style={{ color: 'red' }}>{item.respuesta} </spam></spam>
                                        )
                                    })}
                                </div>
                            }


                            {/* // --- OPCIONES: */}
                            <div className="row">

                                {item.respuestas.map((respuesta, indexx) => {
                                    return (
                                        item.tipo === 'abc' ?
                                            <div className="col-md-6" key={indexx}>
                                                <div className="input-group">
                                                    <div className="input-group-prepend">
                                                        <span className='input-group-text' id='basic-addon1'>{respuesta.id}</span>
                                                    </div>
                                                    <input
                                                        onChange={e => editaOpcion(e, index, indexx)} name="texto" value={respuesta.texto}
                                                        type="text" className="form-control" placeholder="Escribe opción">
                                                    </input>
                                                </div>
                                            </div>
                                            : item.tipo === 'falsoverdadero' ?
                                            null
                                            :
                                            <div className='row'  style={{ paddingLeft: 15, paddingRight: 15 }}>
                                                <div className="col-md-7">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className='input-group-text' id='basic-addon1'>Frase {indexx + 1}</span>
                                                        </div>
                                                        <input
                                                            onChange={e => editaOpcion(e, index, indexx)} name="frase" value={respuesta.frase}
                                                            type="text" className="form-control" placeholder="Escribe Frase">
                                                        </input>
                                                    </div>
                                                </div>
                                                <div className="col-md-5">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <span className='input-group-text' id='basic-addon1'>Respuesta</span>
                                                        </div>
                                                        <input
                                                            onChange={e => editaOpcion(e, index, indexx)} name="respuesta" value={respuesta.respuesta}
                                                            type="text" className="form-control" placeholder="Escribe Respuesta">
                                                        </input>
                                                    </div>
                                                </div>
                                            </div>
                                    )
                                })
                                }
                            </div>
                            {/* // --- RESPUESTA: */}
                            {item.tipo === 'abc' ?
                                <select
                                    className="browser-default custom-select selectAtri" name="acertada" value={item.acertada}
                                    onChange={e => editaPregunta(e, index)}>
                                    <option value="">Selecciona Respuesta Correcta</option>
                                    <option value="a">a)</option>
                                    <option value="b">b)</option>
                                    <option value="c">c)</option>
                                    <option value="d">d)</option>
                                </select>
                                : item.tipo === 'falsoverdadero' ?
                                    <select
                                        className="browser-default custom-select selectAtri" name="acertada" value={item.acertada}
                                        onChange={e => editaPregunta(e, index)}>
                                        <option value="">Selecciona Respuesta Correcta</option>
                                        <option value="falso">Falso</option>
                                        <option value="verdadero">Verdadero</option>
                                    </select>
                                    : null
                            }

                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default CreaQuiz